"use client";

import Link from "next/link";
import Image from "next/image";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "/#products",       label: "Sản phẩm" },
  { href: "/#story",          label: "Câu chuyện" },
  { href: "/#process",        label: "Quy trình" },
  { href: "/#certifications", label: "Chứng nhận" },
  { href: "/#contact",        label: "Liên hệ" },
  { href: "/#feedback",       label: "Góp ý" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-blue-100 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center">
          <Image
            src="/LOGO_DUY THANH.png"
            alt="Công ty Duy Thành"
            width={220}
            height={66}
            className="object-contain h-14 w-auto"
            priority
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex gap-5 text-sm text-zinc-700">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className="hover:text-[color:var(--brand)] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <Link
          href="/#contact"
          className="hidden lg:inline-flex items-center rounded-md bg-[color:var(--brand)] px-4 py-2 text-sm font-semibold text-white hover:bg-[color:var(--brand-dark)] transition-colors"
        >
          Đặt hàng ngay
        </Link>

        {/* Mobile hamburger */}
        <button
          className="lg:hidden p-2 text-zinc-600"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden border-t border-blue-100 bg-white px-4 pb-4">
          <nav className="flex flex-col gap-3 pt-3 text-sm">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                className="text-zinc-700 hover:text-[color:var(--brand)] transition-colors py-1"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}
            <Link
              href="/#contact"
              className="mt-2 inline-flex justify-center rounded-md bg-[color:var(--brand)] px-4 py-2 text-sm font-semibold text-white"
              onClick={() => setOpen(false)}
            >
              Đặt hàng ngay
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
